<app-spinner *ngIf="loading" fill></app-spinner>

<div *ngIf="!loading && riskCount == 0" class="no-data">
  <h2>{{ "risks.no_risk" | translate }}</h2>
</div>

<div class="risks-container" *ngIf="!loading">
  <div class="card-container">
    <div class="card-wrapper" *ngFor="let img of paginatedImages" [id]="'risk-' + img.attachmentId">
      <mat-card class="risk-card">
        <mat-card-content class="card-content">
          <app-gallery *ngIf="img.attachment?.url" [id]="img.attachment!.id" [name]="img.attachment!.name"
            [url]="img.attachment!.url" [tags]="img.attachment!.tags"
            [prediction]="img.attachment!.predictions" [craneCycle]="selectedRisk(img).payload.title"
            [startDate]="selectedRisk(img).payload.startDate" [endDate]="selectedRisk(img).payload.endDate"
            [project]="project" [metric]="selectedRisk(img)" [tracker]="selectedRisk(img).tracker"
            [tagNames]="tagNames" [isDialog]="false" [user]="user" [tagDisplayConfig]="tagDisplayConfig"
            [customVisionIds]="img.attachment!.customVisionIds" [processed]="img.attachment!.processed"
            [riskNumbers]="numbersByImage[img.attachmentId]"
            [hiddenTags]="hiddenRiskTitles" maxImageHeight="70vh">
          </app-gallery>

          <img src="/img/default_project.png" alt="Default risk" class="gallery-img" *ngIf="!img.attachment?.url">

          <app-risk-detail-panel class="risk-info" [image]="img"
            [selectedNumber]="selectedByImage[img.attachmentId]" [actionsByRisk]="actionsByRisk"
            (select)="selectedByImage[img.attachmentId] = $event"
            (showImage)="onShowImage(selectedRisk(img))"
            (report)="reportRisk(selectedRisk(img))"
            (linkAction)="linkAction(selectedRisk(img))"
            (openAction)="openAction($event)"
            (commentEdit)="onCommentEdit(selectedRisk(img))">
          </app-risk-detail-panel>
        </mat-card-content>
      </mat-card>
    </div>
  </div>

  <mat-paginator *ngIf="imageCount > 0" [length]="imageCount" [pageSize]="pageSize" [pageSizeOptions]="[5, 10, 20]"
    (page)="onPageChange($event)">
  </mat-paginator>
</div>